import { GlobalCalendarLanguage, GlobalCalendarType } from 'owa-datetime';

export function validateGlobalCalendarLanguageValue(
    languageValue: string
): GlobalCalendarLanguage | null {
    if (Object.values(GlobalCalendarLanguage).includes(languageValue)) {
        return languageValue as GlobalCalendarLanguage;
    }

    return null;
}

export function validateGlobalCalendarTypeValue(typeValue: string): GlobalCalendarType | null {
    if (Object.values(GlobalCalendarType).includes(typeValue)) {
        return typeValue as GlobalCalendarType;
    }

    return null;
}
